import { useQuery } from '@tanstack/react-query';
import { get } from '../api-client';
import type { FlagListResponse } from '@/types/scheduling-api';

export function useFlagList() {
  return useQuery({
    queryKey: ['flag-list'],
    queryFn: ({ signal }) =>
      get<FlagListResponse[]>('/api/Appointment/GetFlagList?searchText=', { signal }),
  });
}
